<template>
  <div class="page-main">

    <div class="app-head">
        <nav-bar
            title="星巴克在线点单系统"
        >
        </nav-bar>

        <div class="head-tab">
            <router-link class="tab-item" active-class="active" :to="{name:'shopping'}">菜单</router-link>
            <router-link class="tab-item" active-class="active" :to="{name:'history'}">历史订单</router-link>
			<router-link class="tab-item" active-class="active" :to="{name:'historytwo'}">待取订单</router-link>
        </div>
    </div>
    
    <router-view/>
  </div>
</template>

<script>
import { NavBar } from "vant";
export default {
    props:[
        'store'
    ],
    components:{
        NavBar
    }
}
</script>

<style lang="scss" scoped>
.page-main{
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.placeholder{
    margin-top: 46PX;
    height: 88px;
}
.app-head{
    box-shadow: 0 0 10px rgba(0,0,0,0.15);
    background: #fff;
    z-index: 20;
}

.head-tab{
    height: 88px;
    line-height: 88px;
    display: flex;

    .tab-item{
        position: relative;
        text-align: center;
        padding: 0 20px;
        min-width: 100px;

        &.active::after{
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            height: 6px;
            background: #1f623f;
        }
    }
}
</style>